<template>
    <highcharts
        :options="optionsDatas"
    />
</template>
<script>
export default {
    name: 'SolidGauge',
    data(){
        return{
            optionsDatas: {
                chart: {
                    type: 'solidgauge',
                    events: {
                        click: () => {
                            this.Fn();
                        }
                    },
                    style:{
                        cursor: 'pointer'
                    }
                },
                tooltip:{
                    enabled: false
                },
                title:{
                    text: this.datas.title,
                    style: {
                        color:'#ffffff',
                        fontSize: "0.14rem"
                    },
                    verticalAlign: 'middle',
                },
                plotOptions: {
                    solidgauge: {
                        enableMouseTracking: false,
                        dataLabels: {
                            borderWidth: 0,
                            color: '#ffffff',
                            style: {
                                fontSize: "0.14rem"
                            }
                        }
                    }
                },
                pane: {
                    startAngle: 0,
                    endAngle: 360,
                    background: {
                        borderWidth: 0,
                        backgroundColor: 'rgba(0,0,0,0)'
                    }
                },
                yAxis:{
                    min: 0,
                    max: 100,
                    lineWidth: 0,
                    tickPositions: []
                },
                series: this.datas.series,
            }
        }
    },
    props:{
        datas: {
            type: Object,
            default: () => Object.create(null)
        },
        Fn: {
            type: Function,
            default: () => {}
        }
    }
}
</script>